import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
    showChannelInfo: false,
    showRightPanel: false,
};

const conversationPanelSlice = createSlice({
    name: 'conversationPanelData',
    initialState,
    reducers: {
        toggleLeftPanel: state => {
            state.showRightPanel = false;
            state.showChannelInfo = !state.showChannelInfo;
        },
        toggleRightPanel: state => {
            state.showChannelInfo = false;
            state.showRightPanel = !state.showRightPanel;
        },
        resetPanels: () => initialState,
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { toggleLeftPanel, toggleRightPanel, resetPanels } = conversationPanelSlice.actions;

export default conversationPanelSlice.reducer;
